/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'

/**
 *     Import
 *     - Components
 */
import VariationOptions from '../../../Quote/Step05/components/VariationOptions'
import VariationOptionss from '../../../Quote/Step05c/components/VariationOptions'

export default class CoverOptions extends React.Component<any, any> {
    constructor(props: any) {
        super(props)
        this.state = {
            optionsOpen: true,
        }
    }

    toggleOptionsOpen = () => this.setState({ optionsOpen: !this.state.optionsOpen })

    render() {

        return (
            <div
                className={
                    `mta__other quote__form mta__coverOptions quote__form__group 
                    ${(this.props.isCollectors) ? `step5cOptions` : ``} `
                }
            >
                {(this.props.isCollectors) ?
                    <VariationOptionss
                        handleAdjustChangeOptions={this.props.updateData}
                        toggleOptionsOpen={this.toggleOptionsOpen}
                        optionsOpen={this.state.optionsOpen}
                        values={this.props.data}
                    /> : <VariationOptions
                        handleAdjustChangeOptions={this.props.updateData}
                        toggleOptionsOpen={this.toggleOptionsOpen}
                        optionsOpen={this.state.optionsOpen}
                        values={this.props.data}
                    />
                }

            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/Policies/MTA/components/CoverOptions.tsx